export const DEBUG = true;
export const MODEL_STORAGE_PATH = 'localstorage://./Models/';
export const LABEL_COLUMN_NAME = 'Output';